<template>
    <main id="home-wrapper">
        <div id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'News', url: app_url+'/news', status: true }
                ]"
            ></breadcrumb>
            <section id="home-news" class="section withPad">
                <div class="container">
                    <div class="section_title">
                        <h3>Headline News</h3>
                    </div>
                </div>
                <div class="container">
                    <div class="row-news-list">
                        <NewsCard :news="headlineNews" section="Headline News" shareTitle="Article Share"></NewsCard>
                    </div>
                </div>
            </section>

            <section id="tips-news" class="section withPad">
                <div class="container">
                    <div class="row-grid">
                        <div class="col-grid-60">
                            <div class="item_tips">
                                <div class="section_title">
                                    <h3>Tips</h3>
                                </div>
                                <NewsTips section="Tips"></NewsTips>
                            </div>
                        </div>
                        <div class="col-grid-40">
                            <SosokBrader></SosokBrader>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import NewsCard from "../news/NewsCard";
import NewsTips from "../news/NewsTips";
import SosokBrader from "../news/SosokBrader";
import EventCard from "../../widget/EventCard";
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        Carousel,
        Slide,
        breadcrumb: BreadCrumb,
        NewsCard,
        EventCard,
        NewsTips,
        SosokBrader
    },
    data() {
        return {
            show: false,
            mobile: false,
            length: 25,
            headlineNews: null,
            base_url:'',
            app_url:'',
            api_url:'',
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getHeadlineNews();
    },
    methods: {
        showShare() {
            this.show = !this.show;
        },
        getHeadlineNews() {
            axios
                .get(api_url+"/news-headline")
                .then(res => {
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.headlineNews = res?.data?.data?.headlineNews;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<style scoped lang="scss">
.img-promo-section {
    border-radius: 0px;
    overflow: hidden;
    img {
        width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.btn-share a {
    margin-top: 15px;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
@media all and (max-width: 767px) {
    .content-promo-section {
        padding-left: 15px;
        padding-right: 15px;
    }
    .offset-section {
        padding-left: 30px;
    }
    .section_title.red_title h3 {
        font-size: 24px;
        padding: 10px 15px;
    }
}
</style>
